import { ErrorResponse, NotificationStatus, PackingStatus, TransactionType, TransferStatusEnum } from '@gtpl/shared-models/common-models';
import { AllLocationResponseModel, LocationDetails, LocationDto, RackPositionIdRequest } from '@gtpl/shared-models/masters';
import { CommonResponse, ForkLiftJobStatusRequest, ForkLiftJobUpdateRequest } from '@gtpl/shared-models/warehouse-management';
import { ForkLiftItemsDTO, ForkLiftJobDTO, ForkLiftJobIdRequest, GetAllForkLiftJobsResponseModel, GetForkLiftJobResponseModel, JobIdRequest, PlantIdRequest, RepackingDtoRequest, StockDTO, updateJobQty } from '@gtpl/shared-models/warehouse-management';
import { LocationsService, RackEndCustomerMapService } from '@gtpl/shared-services/masters';
import { SaleOrderService } from '@gtpl/shared-services/sale-management';
import { FGStockService, ForkLiftJobService } from '@gtpl/shared-services/warehouse-management';
import { Body, Injectable } from '@nestjs/common';
import { InjectRepository } from '@nestjs/typeorm';
import { SoItemDetailsBySoIdDTO } from 'libs/shared-models/sale-management/src/lib/sale-order/dto/so-item-details-by-so-id.dto';
import { getConnection, getManager, Repository } from 'typeorm';
import { ForkLiftItems } from '../fork-lift-items/fork-lift-items.entity';
import { CreateNotification } from '../notifications/dto/create-notification.dto';
import { NotificationsService } from '../notifications/notifications.service';
import { StockIn } from '../stock-in/stock-in.entity';
import { DriverJobDto } from '../stock/dto/driver-job.dto';
import { FgStockStatus } from '../stock/dto/fg-stock-status.enum';
import { ForkLiftJobUpdateDto } from '../stock/dto/fork-lift-job-update.dto';
import { OutBoundRequest } from '../stock/dto/out-bound.request';
import { StockStatus } from '../stock/dto/stock-status.enum';
import { StockDto } from '../stock/dto/stock.dto';
import { Stock } from '../stock/stock.entity';
import { ForkLiftJobStatus } from './dto/fork-lift-job-status.enum';
import { ForkLiftJobAdapter } from './dto/fork-lift-job.adapter';
import { ForkLiftJobDto } from './dto/fork-lift-job.dto';
import { ForkLiftJobRequest } from './dto/fork-lift-job.request';
import { ForkLiftResponseDto } from './dto/fork-lift-response.dto';
import { ForkLiftUpdateRequest } from './dto/fork-lift-update.request';
import { LocationSuggestRequest } from './dto/location-suggest.request';
import { ForkLiftJobs } from './fork-lift-jobs.entity';
import {appSettings} from '../../../../config';
import { CancelDriverJobRequest } from './dto/cancel-driver-job.request';
import { ForkliftJobDto } from '../stock/dto/fork-lift-jobs.dto';
import { FgStockStates } from '../stock/dto/fg-stock-states.enum';
import { DeviceRequest } from './dto/device.request';

@Injectable()
export class ForkLiftJobsService {
    constructor(
        @InjectRepository(ForkLiftJobs)
        private forkLiftRepository: Repository<ForkLiftJobs>,
        @InjectRepository(ForkLiftItems)
        private forkLiftItemRepository: Repository<ForkLiftItems>,
        private forkLiftJobAdapter:ForkLiftJobAdapter,
        private stockService:FGStockService,
        private soService:SaleOrderService,
        private locationsService:LocationsService,
        private rackEndCustomerMapService:RackEndCustomerMapService,
        private notificationService : NotificationsService,
        private forkLiftJobService: ForkLiftJobService,
        @InjectRepository(Stock)
        private stockRepo: Repository<Stock>,

      ) {}

     async createForkLiftJob(forkLiftJobDto: ForkLiftJobDto, isUpdate: boolean,request:Request): Promise<GetForkLiftJobResponseModel> {
      try {
        let count = await this.forkLiftRepository.count();
        count = count + 1;
          const convertedForkLiftJobEntity: ForkLiftJobs = this.forkLiftJobAdapter.convertDtoToEntity(forkLiftJobDto,isUpdate,count);
          const savedForkLiftJobEntity: ForkLiftJobs = await this.forkLiftRepository.save(
              convertedForkLiftJobEntity
          );
          const savedForkLiftJobDto: ForkLiftResponseDto = this.forkLiftJobAdapter.convertEntityToDto(savedForkLiftJobEntity);
          if (savedForkLiftJobDto) {
              const response = new GetForkLiftJobResponseModel(true,savedForkLiftJobDto ? 11100:11101,savedForkLiftJobDto? 'ForkLiftJob raised Successfully':'Something went wrong',savedForkLiftJobDto);
              return response;
          } else {
          throw new ErrorResponse(11106,'Something Went Wrong');
          }
      } catch (error) {
          throw error;
      }
  }
  async updateForkLiftJobStatus(forkLiftJobRequest:ForkLiftJobRequest):Promise<GetForkLiftJobResponseModel>{
    try {
        const forkLiftData = await this.forkLiftRepository.findOne({
            relations:["forkLiftItemsInfo", "reportingInfo"],
            // select:['status','jobId'],
            where:{jobId:forkLiftJobRequest.jobId}});
            console.log('forkLiftData'+forkLiftData.reportedId);
        let forkLiftStatus = forkLiftJobRequest.status;
        if(forkLiftJobRequest.status != ForkLiftJobStatus.Completed){
            const updateStatus = await getConnection()
            .createQueryBuilder()
            .update(ForkLiftJobs)
            .set({ status: forkLiftStatus})
            .where("job_id = "+forkLiftJobRequest.jobId)
            .execute();
            if(updateStatus){
                const updateRackPosition = await getConnection()
                .createQueryBuilder()
                .update(ForkLiftItems)
                .set({ realPosition:forkLiftJobRequest.rackPosition })
                .where("fork_lift_job_id = "+forkLiftJobRequest.jobId)
                .execute();
                console.log(updateRackPosition);
                if(updateRackPosition.affected>0){
                    const response = new GetForkLiftJobResponseModel(true,11100 ,'Updated ForkLiftJob',forkLiftData);
                    return response;
                }
                else{
                    const response = new GetForkLiftJobResponseModel(true,11101 ,'Something went wrong',forkLiftData);
                    return response;
                }
            }
            else{
                const response = new GetForkLiftJobResponseModel(true,11101 ,'Something went wrong',forkLiftData);
                return response;
            }
        }
        else{
            const reportedCases=await getConnection().createQueryBuilder().from(StockIn, "StockIn").where("reporting_log_id= " + forkLiftData.reportedId).getRawOne();
            console.log('reportedCases'+reportedCases.reported_cases);
            const getSOItemDetails = await this.soService.getSaleOrderItemDetails({saleOrderId:forkLiftData.forkLiftItemsInfo[0].saleOrderId,saleOrderItemId:forkLiftData.forkLiftItemsInfo[0].saleOrderItemId});
            console.log(getSOItemDetails.data);
            if(forkLiftData){
                const updateStatus = await getConnection()
                    .createQueryBuilder()
                    .update(ForkLiftJobs)
                    .set({ status: forkLiftStatus })
                    .where("job_id = "+forkLiftJobRequest.jobId)
                    .execute();
                if(updateStatus){
                    const updateRackPosition = await getConnection()
                    .createQueryBuilder()
                    .update(ForkLiftItems)
                    .set({ realPosition:forkLiftJobRequest.rackPosition })
                    .where("fork_lift_job_id = "+forkLiftJobRequest.jobId)
                    .execute();
                    console.log(updateRackPosition);
                    console.log(forkLiftData);

                    if(updateRackPosition.affected>0){
                        console.log("jiii");
                        const getStockData = await this.stockService.getStockBySoItemId({saleOrderItemId:forkLiftData.forkLiftItemsInfo[0].saleOrderItemId});
                        console.log('getStockData'+getStockData.data);
                        if(getStockData.status){
                            const stock = getStockData.data;
                            let totalCartons = 0;
                            let totalPouches = 0;
                            let loosePouches = 0;
                            let stockType;

                            if(reportedCases.pallet_id === stock.pallet){
                                totalCartons = Number(stock.totalCartons) + Number(reportedCases.reported_cases);
                                totalPouches = Number(stock.totalPouches)  + Number(reportedCases.reported_cases * getSOItemDetails.data.pouches);
                                loosePouches = Number(stock.loosePouches) + Number(reportedCases.loose_pouches);
                                console.log('totalCartons'+totalCartons+'totalPouches'+totalPouches+'loosePouches'+loosePouches);
                                stockType = "Update";
                            }
                            else{
                                totalCartons = reportedCases.reported_cases;
                                totalPouches = reportedCases.reported_cases * getSOItemDetails.data.pouches;
                                loosePouches = reportedCases.loose_pouches;
                                console.log('totalCartons'+totalCartons+'totalPouches'+totalPouches+'loosePouches'+loosePouches);
                                stockType = "Create";

                            }
                            const stockData = new StockDTO(stock.saleOrderId,stock.saleOrderItemId,totalCartons,totalPouches,loosePouches,forkLiftJobRequest.rackPosition,reportedCases.pallet_id,stock.date,stock.stockType,stock.status,reportedCases.lot_code,stock.transactionType,forkLiftData.reportingInfo.shift,forkLiftData.reportingInfo.packingCompleted,stock.stockId,stock.brandId,stock.minGrade,stock.maxGrade,stock.varientId,stock.pouches,stock.pouchWeight,stock.categoryId,stock.productId,stock.palletInfo,stock.locationInfo,stock.saleOrderInfo,stock.saleOrderItemsInfo,stock.updatedUser);
                            console.log('jdcjdv'+stock.stockId)
                            const updateStock = stockType==="Create"?await this.stockService.createStock(stockData):await this.stockService.updateStock(stockData);
                            const response = new GetForkLiftJobResponseModel(true,updateStock.status ? 11100:11101,updateStock? 'Updated ForkLift Job status, Stock updated Successfully':'Something went wrong',forkLiftData);
                            return response;
                        }
                        else if(!getStockData.status){
                            console.log('getSOItemDetailsgetSOItemDetails'+ getSOItemDetails.data.productId);
                            const totalCartons = reportedCases.reported_cases;
                            const totalPouches = reportedCases.reported_cases*getSOItemDetails.data.pouches;
                            const loosePouches = reportedCases.loose_pouches;
                            const productId = getSOItemDetails.data.productId;
                            console.log(productId);
                            console.log('totalCartons'+totalCartons+'totalPouches'+totalPouches+'loosePouches'+loosePouches);
                            const stockData = new StockDTO(forkLiftData.forkLiftItemsInfo[0].saleOrderId,forkLiftData.forkLiftItemsInfo[0].saleOrderItemId,totalCartons,totalPouches,loosePouches,forkLiftJobRequest.rackPosition,forkLiftData.forkLiftItemsInfo[0].pallet,new Date(),StockStatus.SaleOrder,FgStockStatus.StockIn,reportedCases.lot_code,forkLiftData.transactionType,forkLiftData.reportingInfo.shift,forkLiftData.reportingInfo.packingCompleted,0,getSOItemDetails.data.brandId,getSOItemDetails.data.minGrade,getSOItemDetails.data.maxGrade,getSOItemDetails.data.varientId,getSOItemDetails.data.pouches,getSOItemDetails.data.pouchWeight,getSOItemDetails.data.categoryId,productId);
                            console.log('stockDatastockDatastockDatastockDatastockData'+stockData.productId);
                            const createStock = await this.stockService.createStock(stockData);
                            const response = new GetForkLiftJobResponseModel(true,createStock.status ? 11100:11101,createStock? 'Updated ForkLift Job status, Stock created Successfully':'Something went wrong',forkLiftData);
                            return response;
                        }
                    }
                    else{
                    throw new ErrorResponse(11106,'location update is not done, something went wrong.');
                    }
                }else{
                    throw new ErrorResponse(11106,'ForkLiftJob is not updated, something went wrong.');
                }
            }
            else{
            throw new ErrorResponse(11106,'Job not found.');
            }
        }

    } catch (err) {
        throw err;
    }

}
async dispatchStock(forkLiftJobRequest: ForkLiftJobRequest): Promise<GetForkLiftJobResponseModel> {
    try {
        const forkLiftData = await this.forkLiftRepository.findOne({
            relations:["forkLiftItemsInfo"],
            // select:['status','jobId'],
            where:{jobId:forkLiftJobRequest.jobId}});
            console.log('forkLiftData'+forkLiftData);
        const updateForkLiftJob = await getConnection()
        .createQueryBuilder()
        .update(ForkLiftJobs)
        .set({ status: forkLiftJobRequest.status })
        .where("job_id = "+forkLiftJobRequest.jobId)
        .execute();
        console.log(updateForkLiftJob);
        if(updateForkLiftJob.affected>0){
            const updateStock = await getConnection()
            .createQueryBuilder()
            .update(Stock)
            .set({ status: FgStockStatus.StockOut })
            .where("pallet = "+forkLiftData.forkLiftItemsInfo[0].pallet)
            .andWhere("sale_order_item_id = " + forkLiftData.forkLiftItemsInfo[0].saleOrderItemId)
            .execute();
            console.log('updateStock'+updateStock);
            if(updateStock.affected>0){
                return new GetForkLiftJobResponseModel(true,1000,"Stock Dispatched Successfully",forkLiftData)
            }
            else{
                return new GetForkLiftJobResponseModel(false,1000,"Something went wrong",forkLiftData)
            }
        }
        else{
            throw new ErrorResponse(11106,'ForkLiftJob not updated, something went wrong.');
        }
    } catch (error) {
        return error
    }
}
async getDriverJobs(plantIdRequest:PlantIdRequest): Promise<GetAllForkLiftJobsResponseModel> {
    try{
        const getDriverJobs = await this.forkLiftRepository.createQueryBuilder("ForkLiftJobs")
        .leftJoinAndSelect('ForkLiftJobs.forkLiftItemsInfo', 'forkLiftItemsInfo')
        .leftJoinAndSelect('ForkLiftJobs.reportingInfo', 'reportingInfo')
        .where("ForkLiftJobs.status = '"+ ForkLiftJobStatus.Open+ "'").andWhere("ForkLiftJobs.unit_id ="+plantIdRequest.plantId).orderBy("ForkLiftJobs.job_code", "ASC").getMany();
        
        const response:ForkLiftJobDTO[] = [];
        if(getDriverJobs.length>0){
            for (const eachItem of getDriverJobs) {
                const itemsresponse:ForkLiftItemsDTO[] = [];

                for (const item of eachItem.forkLiftItemsInfo) {
                    const getItemDetails = await this.soService.getSaleOrderItemDetailsBySoItemId({saleOrderId:item.saleOrderId,saleOrderItemId:item.saleOrderItemId});
                    console.log('getItemDetails'+getItemDetails)
                    let brand
                    let specie
                    let variety
                    let productForm
                    let freezingType
                    let packingStyle
                    let grade
                    let valAdditionOne
                    let noOfPouches
                    let pouchWeight
                    let productName
                    let uom
                    if(getItemDetails.status){
                        brand = getItemDetails.data.brand;
                        specie = getItemDetails.data.specie;
                        variety = getItemDetails.data.variety;
                        productForm = getItemDetails.data.productForm;
                        freezingType = getItemDetails.data.freezingType;
                        packingStyle = getItemDetails.data.packingStyle + " " + getItemDetails.data.uom;
                        grade = getItemDetails.data.grade
                        valAdditionOne =getItemDetails.data.valAdditionOne;
                        noOfPouches =getItemDetails.data.noOfPouches;
                        pouchWeight =getItemDetails.data.pouchWeight;
                        productName = getItemDetails.data.productName;
                        uom = getItemDetails.data.uom;
                    }
                    else{
                        brand = undefined;
                        specie = undefined;
                        variety = undefined;
                        productForm = undefined;
                        freezingType = undefined;
                        packingStyle = undefined;
                        grade = undefined;
                        valAdditionOne = undefined;
                        noOfPouches = undefined;
                        pouchWeight = undefined;
                        productName = undefined;
                        uom = undefined;
                    }
                   const itemData = new ForkLiftItemsDTO(item.saleOrderId,item.saleOrderItemId,item.pallet,item.currentPosition,item.targetPosition,item.realPosition,item.date,item.createdUser,item.updatedUser,undefined,brand,specie,variety,productForm,freezingType,packingStyle,uom,grade,valAdditionOne,noOfPouches,pouchWeight,productName);
                   itemsresponse.push(itemData);
                }
                const data = new ForkLiftJobDTO(eachItem.jobId,eachItem.jobCode,eachItem.transactionTime,eachItem.status,eachItem.reportedId,eachItem.transactionType,itemsresponse,eachItem.createdUser,eachItem.plantId,eachItem.reportingInfo.lotCode,eachItem.updatedUser);
                response.push(data);
            }
            console.log(response);
            return new GetAllForkLiftJobsResponseModel(true, 1001,"Driver Jobs retrived successfully. ", response);
        }
        else{
            return new GetAllForkLiftJobsResponseModel(false, 1010,"No data found. ", response);
        }

    }catch (error) {
        return error
    }
}
async cancelDriverJob(@Body() outBoundRequest:CancelDriverJobRequest):Promise<CommonResponse>{
    try{
        const getJobDetails = await this.forkLiftRepository.createQueryBuilder("ForkLiftJobs")
        .select("ForkLiftJobs.job_id as jobId,ForkLiftJobs.job_purpose as jobPurpose,flji.pallet as pallet")
        .leftJoin('ForkLiftJobs.forkLiftItemsInfo', 'flji')
        .where("flji.pallet ="+outBoundRequest.palletId)
        .andWhere("ForkLiftJobs.unit_id ="+outBoundRequest.plantId).andWhere("ForkLiftJobs.status = '"+ForkLiftJobStatus.Open + "'").getRawOne();
        console.log('forkLiftJob'+getJobDetails);
        if(getJobDetails.jobId>0){
            const cancelJob = await getConnection()
            .createQueryBuilder()
            .update(ForkLiftJobs)
            .set({ status: ForkLiftJobStatus.Cancelled})
            .where("job_id = "+getJobDetails.jobId)
            .execute();
            if(cancelJob.affected>0){
                const response = new CommonResponse(true,11100 ,'ForkLiftJob cancelled. ',cancelJob);
                return response;
            }
            else{
                const response = new CommonResponse(true,11101 ,'Something went wrong',cancelJob);
                return response;
            }
        }
    }catch (error) {
        return error
    }
}


// async suggestLocation(locationSuggestRequest:LocationSuggestRequest):Promise<AllLocationResponseModel>{
//     try {
//         const locationDto:LocationDetails[]=[];
//         const locationCheck = await this.stockService.getStockBySoId({saleOrderId:locationSuggestRequest.saleOrderId});
//         console.log(locationCheck);
//         if(locationCheck.data.length>0){
//             for (const eachItem of locationCheck.data) {
//                 const locationdata = new LocationDto(eachItem.locationInfo.rackId,eachItem.locationInfo.zoneId,eachItem.locationInfo.levelId,eachItem.locationInfo.columnId,eachItem.locationInfo.locationStatus,eachItem.locationInfo.locationName,eachItem.locationInfo.createdUser,eachItem.locationInfo.locationId,eachItem.locationInfo.isActive,eachItem.locationInfo.updatedUser,eachItem.locationInfo.versionFlag);
//                 locationDto.push(locationdata);
//             }
//         }
//         else{
//             const getEndCustomer = await this.saleOrderService.getSaleorderDataById({saleOrderId:locationSuggestRequest.saleOrderId})
//             if(getEndCustomer.status){
//                 const getRacksByEndCust = await this.rackEndCustomerMapService.getAllRacksByEndCustomer({endCustomerId:getEndCustomer.data.soInvDetailsInfo.endCustomerId});
//             for (const eachItem of getRacksByEndCust.data) {
//                 const getLocationsData = this.locationsService.getAllLocationsByZoneAndRack({rackId:eachItem.rackId,zoneId:eachItem.zoneId});
//                 for (const eachItem of (await getLocationsData).data) {
//                     const locationdata = new LocationDto(eachItem.rackId,eachItem.zoneId,eachItem.levelId,eachItem.columnId,eachItem.locationStatus,eachItem.locationName,eachItem.createdUser,eachItem.locationId,eachItem.isActive,eachItem.updatedUser,eachItem.versionFlag);
//                     locationDto.push(locationdata);
//                 }
//             }

//             }
//         }
//         const response = new AllLocationResponseModel(true,locationDto ? 11100:11101,locationDto? 'Stock Reported Successfully':'Something went wrong',locationDto);
//               return response;
//     } catch (err) {
//         throw err;
//     }
// }

    /**
     * This service is used to update postions of pallet by c72
     * @param ForkLiftUpdateRequest 
     * @returns 
     */
    async updateDriverJob(forkLiftUpdateRequest:ForkLiftUpdateRequest):Promise<CommonResponse>{
        const forkLiftJob = await this.forkLiftRepository.createQueryBuilder("ForkLiftJobs")
        .select("ForkLiftJobs.job_id as jobId,ForkLiftJobs.job_purpose as jobPurpose,flji.pallet as pallet")
        .leftJoin('ForkLiftJobs.forkLiftItemsInfo', 'flji')
        .where("ForkLiftJobs.jobId ="+forkLiftUpdateRequest.jobId)
        .andWhere("ForkLiftJobs.unit_id ="+forkLiftUpdateRequest.plantId).andWhere("ForkLiftJobs.status = '"+ForkLiftJobStatus.Open + "'").getRawOne();
        console.log('forkLiftJob'+forkLiftJob);

        if(forkLiftJob != undefined){
            if(forkLiftUpdateRequest.realPosition!==forkLiftUpdateRequest.targetPosition){
                const notificationDto = new CreateNotification();
                notificationDto.plantId = forkLiftUpdateRequest.plantId;
                notificationDto.palletId = forkLiftJob.pallet;
                notificationDto.jobId = forkLiftJob.jobId;
                notificationDto.status = NotificationStatus.Open;
                notificationDto.statusMessage = forkLiftJob.transactionType;
                notificationDto.createdUser = forkLiftUpdateRequest.updatedUser;
                await this.notificationService.createNotification(notificationDto);
            }
            const forkLiftEntity = new ForkLiftJobs();
            forkLiftEntity.jobId = forkLiftJob.jobId;
            await this.forkLiftItemRepository.update({pallet:forkLiftJob.pallet,forkLiftJobInfo:forkLiftEntity},
                {targetPosition:forkLiftUpdateRequest.targetPosition,realPosition:forkLiftUpdateRequest.realPosition,updatedAt:forkLiftUpdateRequest.updatedAt,updatedUser:forkLiftUpdateRequest.updatedUser});
            return new CommonResponse(true,10000,'Driver job updated successfully');  
        }
        else{
            throw new ErrorResponse(10000,'Pallet details not found in fork lift jobs');
        }
    }
    /**
     * This service is used to update postions of pallet by fork lift machine
     * @param forkLiftJobUpdateDto 
     * @returns 
     */
    async updateDriverJobByForkLift(forkLiftJobUpdateDto:ForkLiftJobUpdateDto):Promise<CommonResponse>{
        const forkLiftJob = await this.forkLiftRepository.createQueryBuilder("flj")
        .select("flj.job_id,flj.job_purpose")
        .leftJoin('flj.forkLiftItemsInfo', 'flji')
        .where("flji.pallet ="+forkLiftJobUpdateDto.palletId)
        .andWhere("flj.jobCode ='"+forkLiftJobUpdateDto.jobCode+"'")
        .andWhere("flj.unit_id ="+forkLiftJobUpdateDto.plantId).andWhere("flj.status = '"+ForkLiftJobStatus.Open + "'").getRawOne();

        if(!forkLiftJob){
            throw new ErrorResponse(10000,'Pallet details not found in fork lift jobs');
        }
        if(forkLiftJobUpdateDto.realPosition!==forkLiftJobUpdateDto.targetPosition){
            const notificationDto = new CreateNotification();
            notificationDto.plantId = forkLiftJobUpdateDto.plantId;
            notificationDto.palletId = forkLiftJobUpdateDto.palletId;
            notificationDto.jobId = forkLiftJob.job_id;
            notificationDto.status = NotificationStatus.Open;
            notificationDto.statusMessage = forkLiftJob.job_purpose;
            notificationDto.createdUser = forkLiftJobUpdateDto.updatedUser;
            await this.notificationService.createNotification(notificationDto);
        }
        const forkLiftEntity = new ForkLiftJobs();
        forkLiftEntity.jobId = forkLiftJob.job_id;
        forkLiftEntity.jobCode = forkLiftJob.job_code;
        forkLiftEntity.status = forkLiftJob.status;
        await this.forkLiftItemRepository.update({pallet:forkLiftJobUpdateDto.palletId,forkLiftJobInfo:forkLiftEntity},
            {targetPosition:forkLiftJobUpdateDto.targetPosition,realPosition:forkLiftJobUpdateDto.realPosition,updatedAt:forkLiftJobUpdateDto.updatedAt,updatedUser:forkLiftJobUpdateDto.updatedUser});
        await this.forkLiftRepository.update({jobCode:forkLiftJobUpdateDto.jobCode},
            {status:ForkLiftJobStatus.Completed,updatedAt:forkLiftJobUpdateDto.updatedAt,updatedUser:forkLiftJobUpdateDto.updatedUser});
            const forkLiftData = await this.forkLiftRepository.findOne({
                relations:["forkLiftItemsInfo", "reportingInfo"],
                where:{jobCode:forkLiftJobUpdateDto.jobCode}});
                const reportedCases=await getConnection().createQueryBuilder().from(StockIn, "StockIn").where("reporting_log_id= " + forkLiftData.reportedId).getRawOne();
            console.log('reportedCases'+reportedCases.reported_cases);
            const getSOItemDetails = await this.soService.getSaleOrderItemDetails({saleOrderId:forkLiftData.forkLiftItemsInfo[0].saleOrderId,saleOrderItemId:forkLiftData.forkLiftItemsInfo[0].saleOrderItemId});
            console.log(getSOItemDetails.data);
            const getStockData = await this.stockService.getStockBySoItemId({saleOrderItemId:forkLiftData.forkLiftItemsInfo[0].saleOrderItemId});
                        console.log('getStockData'+getStockData.data);
                        if(getStockData.status){
                            const stock = getStockData.data;
                            let totalCartons = 0;
                            let totalPouches = 0;
                            let loosePouches = 0;
                            let stockType;

                            if(reportedCases.pallet_id === stock.pallet){
                                totalCartons = Number(stock.totalCartons) + Number(reportedCases.reported_cases);
                                totalPouches = Number(stock.totalPouches)  + Number(reportedCases.reported_cases * getSOItemDetails.data.pouches);
                                loosePouches = Number(stock.loosePouches) + Number(reportedCases.loose_pouches);
                                console.log('totalCartons'+totalCartons+'totalPouches'+totalPouches+'loosePouches'+loosePouches);
                                stockType = "Update";
                            }
                            else{
                                totalCartons = reportedCases.reported_cases;
                                totalPouches = reportedCases.reported_cases * getSOItemDetails.data.pouches;
                                loosePouches = reportedCases.loose_pouches;
                                console.log('totalCartons'+totalCartons+'totalPouches'+totalPouches+'loosePouches'+loosePouches);
                                stockType = "Create";
                            }
                            const stockData = new StockDTO(stock.saleOrderId,stock.saleOrderItemId,totalCartons,totalPouches,loosePouches,forkLiftJobUpdateDto.realPosition,reportedCases.pallet_id,stock.date,stock.stockType,stock.status,reportedCases.lot_code,stock.transactionType,forkLiftData.reportingInfo.shift,forkLiftData.reportingInfo.packingCompleted,stock.stockId,stock.brandId,stock.minGrade,stock.maxGrade,stock.varientId,stock.pouches,stock.pouchWeight,stock.categoryId,stock.productId,stock.palletInfo,stock.locationInfo,stock.saleOrderInfo,stock.saleOrderItemsInfo,stock.updatedUser,0,forkLiftJobUpdateDto.plantId);
                            console.log('jdcjdv'+stock.stockId)
                            const updateStock = stockType==="Create"?await this.stockService.createStock(stockData):await this.stockService.updateStock(stockData);
                            const response = new GetForkLiftJobResponseModel(true,updateStock.status ? 11100:11101,updateStock? 'Updated ForkLift Job status, Stock updated Successfully':'Something went wrong',forkLiftData);
                            return response;
                        }
                        else if(!getStockData.status){
                            console.log('getSOItemDetailsgetSOItemDetails'+ getSOItemDetails.data.productId);
                            const totalCartons = reportedCases.reported_cases;
                            const totalPouches = reportedCases.reported_cases*getSOItemDetails.data.pouches;
                            const loosePouches = reportedCases.loose_pouches;
                            const productId = getSOItemDetails.data.productId;
                            console.log(productId);
                            console.log('totalCartons'+totalCartons+'totalPouches'+totalPouches+'loosePouches'+loosePouches);
                            const stockData = new StockDTO(forkLiftData.forkLiftItemsInfo[0].saleOrderId,forkLiftData.forkLiftItemsInfo[0].saleOrderItemId,totalCartons,totalPouches,loosePouches,forkLiftJobUpdateDto.realPosition,forkLiftData.forkLiftItemsInfo[0].pallet,new Date(),StockStatus.SaleOrder,FgStockStatus.StockIn,reportedCases.lot_code,forkLiftData.transactionType,forkLiftData.reportingInfo.shift,forkLiftData.reportingInfo.packingCompleted,0,getSOItemDetails.data.brandId,getSOItemDetails.data.minGrade,getSOItemDetails.data.maxGrade,getSOItemDetails.data.varientId,getSOItemDetails.data.pouches,getSOItemDetails.data.pouchWeight,getSOItemDetails.data.categoryId,productId,null,null,null,null,null,null,forkLiftJobUpdateDto.plantId);
                            console.log('stockDatastockDatastockDatastockDatastockData'+stockData.productId);
                            const createStock = await this.stockService.createStock(stockData);
                            const response = new GetForkLiftJobResponseModel(true,createStock.status ? 11100:11101,createStock? 'Updated ForkLift Job status, Stock created Successfully':'Something went wrong',forkLiftData);
                            return response;
                        }
            return new CommonResponse(true,10000,'Driver job updated successfully',forkLiftEntity);            
    }

    /**
     * This service is used to create new driver job if pallet is not avaible in forklift jobs and if its avaiable updates the postions pallet
     * @param driverJobDto 
     * @returns 
     */
     async createOrUpdateDriverJob(driverJobDto:DriverJobDto):Promise<CommonResponse>{
        const forkLiftJob = await this.forkLiftRepository.createQueryBuilder("flj")
        .select("flj.job_id,flj.job_purpose")
        .leftJoin('flj.forkLiftItemsInfo', 'flji')
        .where("flji.pallet ="+driverJobDto.palletId)
        .andWhere("flj.unit_id ="+driverJobDto.plantId).andWhere("flj.status = '"+ForkLiftJobStatus.Open + "'").getRawOne();
        if(!forkLiftJob){
            const forkLiftEntity = new ForkLiftJobs();
            const count = await this.forkLiftRepository.count();
            forkLiftEntity.jobCode = "JOB/" + count+1;
            forkLiftEntity.status = ForkLiftJobStatus.Open;
            forkLiftEntity.transactionType=TransactionType.unregistered;
            forkLiftEntity.transactionTime=driverJobDto.updatedAt;
            forkLiftEntity.plantId = driverJobDto.plantId;
            forkLiftEntity.message = TransactionType.unregistered;
            forkLiftEntity.createdUser = driverJobDto.userName;
            forkLiftEntity.forkLiftItemsInfo = [];
            const forkLiftItem = new ForkLiftItems();
            forkLiftItem.pallet = driverJobDto.palletId;
            forkLiftItem.currentPosition = driverJobDto.currentPosition;
            forkLiftItem.targetPosition = driverJobDto.currentPosition;
            forkLiftItem.date = driverJobDto.updatedAt;
            forkLiftEntity.forkLiftItemsInfo = [forkLiftItem];
            const forkLiftJobData = await this.forkLiftRepository.save(forkLiftEntity);

            const notificationDto = new CreateNotification();
            notificationDto.plantId = driverJobDto.plantId;
            notificationDto.palletId = driverJobDto.palletId;
            notificationDto.jobId = forkLiftJobData.jobId;
            notificationDto.status = NotificationStatus.Open;
            notificationDto.statusMessage = TransactionType.unregistered;
            notificationDto.createdUser = driverJobDto.userName;
            await this.notificationService.createNotification(notificationDto);
            
            return new CommonResponse(true,10000,'Driver job created successfully');    
        } else {
            const notificationDto = new CreateNotification();
            notificationDto.plantId = driverJobDto.plantId;
            notificationDto.palletId = driverJobDto.palletId;
            notificationDto.jobId = forkLiftJob.job_id;
            notificationDto.status = NotificationStatus.Open;
            notificationDto.statusMessage = TransactionType.stockTransfer;
            notificationDto.createdUser = driverJobDto.userName;
            await this.notificationService.createNotification(notificationDto);
            const forkLiftEntity = new ForkLiftJobs();
            forkLiftEntity.jobId = forkLiftJob.job_id;
            await this.forkLiftItemRepository.update({pallet:driverJobDto.palletId,forkLiftJobInfo:forkLiftEntity},
                {currentPosition:driverJobDto.currentPosition,updatedAt:driverJobDto.updatedAt,updatedUser:driverJobDto.userName});                
            return new CommonResponse(true,10000,'Driver job created successfully');    
        }         
    }
    async getForkliftJobs():Promise<CommonResponse>{
        const manager = getManager();
        const rawData = await manager.query(`SELECT inv.po_number AS poNumber,so.sale_order_no AS saleOrderNumber,s.stock_id AS stockId,s.lot_no AS lotNo,s.total_cartons AS totalCartons,
        s.unit_id AS unitId,s.packing_completed AS packingCompleted,z.zone_name AS coldStorage,r.rack_code AS rackPosition,s.location AS stockLocationId,
        s.pallet_code AS palletCode,b.brand_name AS brandName,p.name AS productName,
        sc.variant_code AS variantCode,CONCAT(s.min_grade,'-',s.max_grade) AS Grade,s.state AS stockState,
        fi.fork_lift_item_id AS forkLiftItemId,fi.sale_order_id AS saleOrderId,fi.sale_order_item_id AS saleOrderItemId,fi.pallet AS pallet,
        fi.current_position AS currentPosition,fi.target_position AS targetPosition,fi.real_position AS realPosition,fi.date AS transactionDate,fi.sync_status AS syncStatus,
        fi.created_at AS createdAt,fi.created_user AS createdUser,fi.updated_at AS updatedAt,fi.updated_user AS updatedUser,fi.fork_lift_job_id AS forkLiftJobId
        FROM `+appSettings.warehouse_db+`.fork_lift_items fi 
        LEFT JOIN `+appSettings.warehouse_db+`.fork_lift_jobs f ON f.job_id=fi.fork_lift_job_id
        LEFT JOIN `+appSettings.warehouse_db+`.reporting r ON r.reporting_log_id=f.reported_id
        LEFT JOIN `+appSettings.warehouse_db+`.stock s ON s.stock_id=r.stock_id
        LEFT JOIN `+appSettings.sales_db+`.so_invoice_details inv ON inv.sale_order_id=s.sale_order_id 
        LEFT JOIN `+appSettings.sales_db+`.sale_order so ON so.sale_order_id=s.sale_order_id 
        LEFT JOIN `+appSettings.masters_db+`.zone_master z ON z.zone_id=s.zone_id
        LEFT JOIN `+appSettings.masters_db+`.rack_position r ON r.rack_id=s.location
        LEFT JOIN `+appSettings.masters_db+`.brands b ON b.brand_id=s.brand_id
        LEFT JOIN `+appSettings.masters_db+`.products p ON p.product_id=s.product_id
        LEFT JOIN `+appSettings.masters_db+`.sku_codes sc ON sc.sku_code_id=s.varient_id
        WHERE f.status IN ('Open','Pending')`);
        if(rawData.length>0){
            return new CommonResponse(true,10000,'Fork lift jobs received successfully',rawData);
        }else{
            return new CommonResponse(true,10000,'There is no pending jobs');
        }
        
    }
    async getForkliftJobCodes(forkliftJobDto:ForkliftJobDto):Promise<CommonResponse>{
        const manager = getManager();
        const rawData = await manager.query(`SELECT f.job_id AS jobId,f.job_code as jobCode
        FROM  `+appSettings.warehouse_db+`.fork_lift_jobs f WHERE f.status IN ('Open','Pending') and f.unit_id=`+forkliftJobDto.unitId+` and f.job_purpose='`+forkliftJobDto.transactionType+`'`);
        if(rawData.length>0){
            return new CommonResponse(true,10000,'Fork lift jobs received successfully',rawData);
        }else{
            return new CommonResponse(false,10100,'There is no pending jobs');
        }
        
    }

    async getForkliftJobCodesForGrid(forkliftJobDto:ForkliftJobDto):Promise<CommonResponse>{
        const manager = getManager();
        try
        {
            let getStockTransferJobItems = 'select s.stock_type AS stockType, fi.sale_order_id AS saleOrderId, fi.sale_order_item_id AS saleOrderItemId, pm.packing_method_name AS packStyle,f.job_id AS jobId,f.job_code as jobCode,f.job_purpose as jobPurpose,f.message as message,f.total_job_cartons as totalJobCartons,f.shortage_cartons as shortageCartons,f.damaged_cartons as damagedCartons,f.tot_issued_quantity as totIssuedQuantity,tot_received_quantity as totReceivedQuantity, excess_quantity as excessQuantity,damaged_quantity as damagedQuantity,f.status as status,sid.po_number AS poNumber,sk.variant_code AS variantCode,fi.job_cartons AS jobCartons,fi.issued_quantity AS issuedQuantity,fi.received_quantity AS receivedQuantity,sync_status as dispatchStatus,rp.rack_code AS location from '+appSettings.warehouse_db+'.fork_lift_items fi LEFT JOIN '+appSettings.warehouse_db+'.stock s on s.stock_id = fi.stock_id LEFT JOIN '+appSettings.warehouse_db+'.fork_lift_jobs f on f.job_id = fi.fork_lift_job_id LEFT JOIN '+appSettings.sales_db+'.so_invoice_details sid on sid.sale_order_id = fi.sale_order_id LEFT JOIN '+appSettings.sales_db+'.sale_order_items si on si.sale_order_item_id = fi.sale_order_item_id LEFT JOIN '+appSettings.masters_db+'.packing_methods pm on pm.packing_method_id = si.pack_style_id LEFT JOIN '+appSettings.masters_db+'.sku_codes sk on sk.sku_code_id = si.varient_id LEFT JOIN '+appSettings.masters_db+'.rack_position rp on rp.rack_position_id = fi.current_position where f.job_purpose IN ("repacking","reprocessing")';
            getStockTransferJobItems = getStockTransferJobItems + ` Group by f.job_id Order by rp.rack_code DESC`;
            const rawData = await manager.query(getStockTransferJobItems);
            let data:any[] =[];
            // let soItemsQuery = `SELECT s.stock_id,so.sale_order_no as saleOrderNo,sid.po_number as assignablePO,min_grade_id as minGrade,max_grade_id as maxGrade,soi.min_glaze,soi.max_glaze,soi.uom_id as uomId,soi.cases,job_cases as jobCases,soi.pouches,soi.soaking_time,soi.soaking_style as soakingStyle,style_weighment as styleWeighment,net_amount as netAmount,unitPrice,soi.pouch_weight as pouchWeight,soi.case_weight as caseWeight,soi.net_weight as netWeight,dispatched_qty as dispatchedQty,inv_amount as invAmount,b.brand_name as brand,soi.master_brand_id as masterBrandId,p.code as itemId,s.variant_code as varientId, soi.category as category,soi.requiredCount as rmCount,b.brand_id as brandId,soi.varient_id as variant,soi.final_percentage as finalPercentage,soi.sale_order_item_id as saleOrderItemId,soi.sale_order_id as saleOrderId, soi.shrimp_weight as netDrainedWeight,rbl.hl_per AS hlPercentage,sid.processing_unit as unitId,s.variant_code as assignableItem FROM ` + appSettings.sales_db + `.sale_order_items soi LEFT JOIN `+ appSettings.masters_db + `.food_types f ON f.food_type_id=soi.food_type_id LEFT JOIN `+ appSettings.sales_db + `.rm_bom_log rbl ON rbl.sale_order_item_id=soi.sale_order_item_id LEFT JOIN `+ appSettings.sales_db + `.so_invoice_details sid ON sid.sale_order_id=soi.sale_order_id LEFT JOIN `+ appSettings.sales_db + `.sale_order so ON so.sale_order_id=sid.sale_order_id LEFT JOIN `+ appSettings.masters_db + `.sku_codes s ON s.sku_code_id=soi.varient_id LEFT JOIN `+ appSettings.masters_db + `.products p ON p.product_id=soi.item_id LEFT JOIN `+ appSettings.masters_db + `.brands b ON b.brand_id=soi.brand_id LEFT JOIN `+ appSettings.masters_db + `.value_addition_one_types va1 ON va1.value_addition_one_id=soi.value_addition_one_id LEFT JOIN `+ appSettings.masters_db + `.value_addition_two_types va2 ON va2.value_addition_two_id=soi.value_addition_two_id LEFT JOIN `+ appSettings.masters_db + `.value_addition_three_types va3 ON va3.value_addition_three_id=soi.value_addition_three_id LEFT JOIN `+ appSettings.masters_db + `.value_addition_four_types va4 ON va4.value_addition_four_id=soi.value_addition_four_id LEFT JOIN `+ appSettings.masters_db + `.value_addition_five_types va5 ON va5.value_addition_five_id=soi.value_addition_five_id LEFT JOIN `+appSettings.warehouse_db+`.stock s ON s.varient_id = soi.varient_id AND s.stock_id = (SELECT MAX(stock_id) FROM `+appSettings.warehouse_db+`.stock s WHERE s.varient_id = soi.varient_id AND s.status = "StockIn" and state = "Stock" AND s.stock_type IN ("dummy","anticipated")) where so.status NOT IN ("CLOSED","CANCELLED") and so_process_type != "MTS" AND s.stock_id >0 and sid.processing_unit = `+forkliftJobDto.unitId;
            // let soData = await manager.query(soItemsQuery);
            // // console.log(soData);
            // for (const [index, soItem] of soData.entries()) {
            //     const rePack = new RepackingDtoRequest();
            //     rePack.brand = soItem.brandId
            //     rePack.brand = soItem.brandId
            //     rePack.product = undefined
            //     rePack.minGrade = undefined
            //     rePack.maxGrade = undefined
            //     rePack.category = undefined
            //     rePack.varient = soItem.variant
            //     rePack.soakingStyle = undefined
            //     rePack.soakingTime = undefined
            //     rePack.masterBrandId = soItem.masterBrandId
            //     rePack.unitId = soItem.unitId
            //     console.log('reeeeeee')
            //     console.log(rePack)
            //     const rePackingQty = this.stockService.getRePackingStock(rePack);
            //     // const finalFG = await manager.query("select SUM(total_cartons) as finalFG from " + appSettings.warehouse_db + ".stock where stock.sale_order_item_id = " + soItem.saleOrderItemId + " and stock.stock_type ='saleOrder'");
            //     // const dummyStock = await manager.query("select SUM(total_cartons) as dummyStock from " + appSettings.warehouse_db + ".stock where stock.sale_order_item_id = " + soItem.saleOrderItemId + " and stock.stock_type IN ('SuperDummy','Anticipated') ");
            //     // console.log(finalFG)
            //     // console.log(dummyStock)
            //     // soData[index].finalFG = finalFG[0].finalFG != null ? finalFG[0].finalFG : 0;
            //     // soData[index].dummyStock = dummyStock[0].dummyStock != null ? dummyStock[0].dummyStock : 0;
            //     // soData[index].balance = Number(soItem.jobCases) - (Number(finalFG[0].finalFG) + Number(dummyStock[0].dummyStock));

            //     await Promise.all([rePackingQty]).then(
            //     (res) => {
            //         const repackingQty = res[0].status ? res[0].data.profitReproceeQty : 0
            //         soData[index].rePackQty = repackingQty;
            //         })
            // };
            // //   console.log(data);
            // console.log(rawData);

            if(rawData.length>0){
                return new CommonResponse(true,10000,'Fork lift jobs received successfully',rawData,data);
            }else{
                return new CommonResponse(false,10100,'There is no pending jobs');
            }
        }
        catch (error) {
            console.log(error);
            return error
        }
        
    }
    async updateForkLiftJobQty(req: updateJobQty): Promise<CommonResponse> {
        console.log(req);
        const manager = getManager();
        if(req.isDamaged === PackingStatus.NO){
            console.log("Damaged No")
            let qur = `select issued_quantity AS issuedQuantity,received_quantity AS receivedQuantity from fork_lift_items where fork_lift_job_id = `+req.jobId+` and sale_order_id = `+req.saleOrderId;
            if(req.transactionType != "reprocessing"){
                qur= qur + " and sale_order_item_id = "+req.saleOrderItemId
            }
            const getJobItemDetails = await manager.query(qur);
           
            console.log("getJobItemDetails"+getJobItemDetails);
            let received_quantity = Number(getJobItemDetails[0].receivedQuantity) + Number(req.receivedqty);
            let excess_quantity = Number(getJobItemDetails[0].issuedQuantity) - Number(req.receivedqty);
            console.log("received_quantity"+received_quantity);
            
            let query = `update fork_lift_items set received_quantity =`+received_quantity+` where fork_lift_job_id = `+req.jobId+` and sale_order_id = `+req.saleOrderId;
            if(req.transactionType != "reprocessing"){
                query= query + " and sale_order_item_id = "+req.saleOrderItemId
            }
            let updateQty = await manager.query(query);
            console.log(updateQty);
            if(updateQty.affectedRows>0){
                const getTotalQtys = await manager.query(`select SUM(received_quantity) AS totReceivedQuantity from fork_lift_items where fork_lift_job_id = `+req.jobId);
                let tot_received_quantity = Number(getTotalQtys[0].totReceivedQuantity);
                const getTotalIssuedQtys = await manager.query(`select excess_quantity AS totExcessQty,tot_issued_quantity AS totIssuedQuantity from fork_lift_jobs where job_id = `+req.jobId);
                console.log(getTotalIssuedQtys);
                let status = ForkLiftJobStatus.Open;
                if(tot_received_quantity >= getTotalIssuedQtys[0].totIssuedQuantity ){
                    status = ForkLiftJobStatus.Completed;
                }
                let totExcessQuantity = Number(getTotalIssuedQtys[0].totExcessQty) + Number(excess_quantity);
                const updateTotQty = await manager.query(`update fork_lift_jobs set tot_received_quantity =`+tot_received_quantity+`,excess_quantity = `+totExcessQuantity+`, status = '`+status+`' where job_id = `+req.jobId);
                if(updateTotQty.affectedRows>0){
                    return new CommonResponse(true,1001,"Recived Qty updated successfully. ");
                }
                else{
                    return new CommonResponse(false,1010,"Something went wrong. ");
                }
            }
            else{
                return new CommonResponse(false,1010,"Something went wrong. ");
            }
        }
        else{
            console.log("Damaged YES")

            const getJobItemDetails = await manager.query(`select damaged_cartons AS damagedCartons, damaged_quantity AS damagedQuantity from fork_lift_items where fork_lift_job_id = `+req.jobId);
            let damagedCartons = getJobItemDetails[0].damagedCartons;
            let damagedQuantity = getJobItemDetails[0].damagedQuantity;

            const updateQty = await manager.query(`update fork_lift_jobs set damaged_cartons =`+damagedCartons+`, damaged_quantity = `+damagedQuantity+` where fork_lift_job_id = `+req.jobId);
            if(updateQty.affected>0){
                return new CommonResponse(true,1001,"Recived Qty updated successfully. ");
            }
            else{
                return new CommonResponse(false,1010,"Something went wrong. ");
            }

        }
        
    }

    async getSosAgainstJob(req: JobIdRequest): Promise<CommonResponse> {
        const manager = getManager();
        let rawData
        if(req.transactionType == "stockTransfer"){
            let varientId = await manager.query("SELECT GROUP_CONCAT(sis.varient_id) AS varientId FROM "+appSettings.warehouse_db + ".fork_lift_items fi LEFT JOIN " +appSettings.warehouse_db +".fork_lift_jobs f ON f.job_id = fi.fork_lift_job_id LEFT JOIN "+appSettings.sales_db+".sale_order_items sis ON sis.sale_order_item_id = fi.sale_order_item_id WHERE f.status IN ('Open','Pending') AND fi.fork_lift_job_id="+req.jobId)
            console.log(varientId);
            rawData = await manager.query("Select si.sale_order_id AS saleOrderId,so.po_number AS saleOrderNumber from "+appSettings.sales_db+".sale_order_items si left join "+appSettings.sales_db+".so_invoice_details so ON so.sale_order_id = si.sale_order_id where varient_id IN ("+varientId[0].varientId+")");
        }
        else{
            rawData = await manager.query(`SELECT s.sale_order_id AS saleOrderId,sid.po_number AS saleOrderNumber
            FROM  `+appSettings.warehouse_db+`.fork_lift_items fi left join `+appSettings.warehouse_db+`.fork_lift_jobs f on f.job_id = fi.fork_lift_job_id left join `+appSettings.sales_db+`.sale_order s on s.sale_order_id = fi.sale_order_id left join `+appSettings.sales_db+`.so_invoice_details sid on sid.sale_order_id = fi.sale_order_id WHERE f.status IN ('Open','Pending') and fi.fork_lift_job_id=`+req.jobId+` group by s.sale_order_id`);
        }
        
        if(rawData.length>0){
            return new CommonResponse(true,10000,'Sale Orders received successfully',rawData);
        }else{
            return new CommonResponse(false,10100,'No sale Orders found. ');
        }
    }
    async getAllStockTranserDcData(req: PlantIdRequest): Promise<CommonResponse> {
        const manager = getManager();
        try{
            // let getStockTransferJobs = `select fj.job_code AS jobCode,fj.job_purpose AS jobPurpose, fj.status AS status,so.po_number AS poNumber,u.unit_name AS fromPlant, tu.unit_name AS toPlant,fi.job_cartons AS jobCartons,received_quantity AS receivedQuantity from `+appSettings.warehouse_db+`.fork_lift_items fi left join `+appSettings.warehouse_db+`.fork_lift_jobs fj on fj.job_id = fi.fork_lift_job_id left join `+appSettings.sales_db+`.so_invoice_details so on so.sale_order_id = fi.sale_order_id left join `+appSettings.masters_db+`.unitcodes u on u.unit_code_id=fj.from_plant_id left join `+appSettings.masters_db+`.unitcodes tu on tu.unit_code_id=fj.to_plant_id where fj.job_purpose='stockTransfer'`;
            // if(req.plantId != 5){
            //     getStockTransferJobs = getStockTransferJobs + ` and fj.from_plant_id = `+req.plantId;
            // }
            // getStockTransferJobs = getStockTransferJobs + ` Order by Date(fj.date) DESC , so.po_number`;
            
            let getStockTransferJobs = 'select date AS jobDate , job_id AS jobId,job_code AS jobCode,status AS status,job_purpose AS jobPurpose, date AS date, unit_id AS unitId, total_job_cartons AS totalJobCartons, tot_received_quantity AS totReceivedQuantity, excess_quantity AS excessQuantity, damaged_quantity AS damagedQuantity, transfer_status AS transferStatus,uc.unit_name AS fromPlant, u.unit_name AS toPlant, transfer_status AS transferStatus  from '+appSettings.warehouse_db+'.fork_lift_jobs fj LEFT JOIN '+appSettings.masters_db+'.unitcodes uc on uc.unit_code_id = fj.from_plant_id LEFT JOIN '+appSettings.masters_db+'.unitcodes u on u.unit_code_id = fj.to_plant_id where fj.job_purpose = "stockTransfer"';
            if(req.plantId != 5){
                getStockTransferJobs = getStockTransferJobs + ' and fj.from_plant_id = '+req.plantId;
            }
            getStockTransferJobs = getStockTransferJobs + ` Order by Date(fj.date) DESC`;
            
            const response = await manager.query(getStockTransferJobs);
            if(getStockTransferJobs.length > 0){
                return new CommonResponse(true,1001,"Stock Transfer jobs retrived successfully. ",response);
            }
            else{
                return new CommonResponse(false,1001,"No data found. ");
            }
        }
        catch (error) {
            return error
        }
    }
    async getStockTranserItemsData(req: JobIdRequest): Promise<CommonResponse> {
        const manager = getManager();
        try{
            let getStockTransferJobItems = 'select sid.po_number AS poNumber,sk.variant_code AS variantCode,SUM(fi.job_cartons) AS jobCartons,SUM(fi.issued_quantity) AS issuedQuantity,SUM(fi.received_quantity) AS receivedQuantity from '+appSettings.warehouse_db+'.fork_lift_items fi LEFT JOIN '+appSettings.sales_db+'.so_invoice_details sid on sid.sale_order_id = fi.sale_order_id LEFT JOIN '+appSettings.sales_db+'.sale_order_items si on si.sale_order_item_id = fi.sale_order_item_id LEFT JOIN '+appSettings.masters_db+'.sku_codes sk on sk.sku_code_id = si.varient_id where fi.fork_lift_job_id = '+req.jobId;
            getStockTransferJobItems = getStockTransferJobItems + ` Group by si.varient_id Order by Date(sid.po_number) DESC`;
            
            const response = await manager.query(getStockTransferJobItems);

            if(response.length > 0){
                return new CommonResponse(true,1001,"Stock Transfer jobs retrived successfully. ",response);
            }
            else{
                return new CommonResponse(false,1001,"No data found. ");
            }
        }   
        catch (error) {
            return error
        }
    }
    // async getAllForkLiftItemsByJobId(req: ForkLiftJobIdRequest): Promise<CommonResponse> {
    //     const manager = getManager();
    //     try{
    //         let getStockTransferJobItems = 'select sid.po_number AS poNumber,sk.variant_code AS variantCode,fi.job_cartons AS jobCartons,fi.issued_quantity AS issuedQuantity,fi.received_quantity AS receivedQuantity,sync_status as dispatchStatus,rp.rack_code AS location from '+appSettings.warehouse_db+'.fork_lift_items fi LEFT JOIN '+appSettings.sales_db+'.so_invoice_details sid on sid.sale_order_id = fi.sale_order_id LEFT JOIN '+appSettings.sales_db+'.sale_order_items si on si.sale_order_item_id = fi.sale_order_item_id LEFT JOIN '+appSettings.masters_db+'.sku_codes sk on sk.sku_code_id = si.varient_id LEFT JOIN '+appSettings.masters_db+'.rack_position rp on rp.rack_position_id = fi.current_position where fi.fork_lift_job_id = '+req.jobId;
    //         getStockTransferJobItems = getStockTransferJobItems + ` Order by rp.rack_code DESC`;
    //         const response = await manager.query(getStockTransferJobItems);
    //         let query = `SELECT soi.po_number as poNumber,sc.variant_code as variantCode,SUM(total_cartons),SUM(IF(u.uom_name = 'OZ' , (s.total_cartons * pm.no_of_pouches * pm.pouches_per_row * 0.0625), IF(u.uom_name = 'KG' ,(s.total_cartons * pm.no_of_pouches * pm.pouches_per_row * 2.20462), IF(uom_name = 'GM' ,(s.total_cartons * pm.no_of_pouches * pm.pouches_per_row * 0.0022),(s.total_cartons * pm.no_of_pouches * pm.pouches_per_row)))))AS allocatedQty FROM ` + appSettings.warehouse_db + `.stock s LEFT JOIN `+ appSettings.sales_db + `.so_invoice_details soi ON soi.sale_order_id=s.allocated_sale_order_id
    //          LEFT JOIN `+ appSettings.sales_db + `.sale_order_items si ON si.sale_order_item_id=s.allocated_sale_orderitem__id
    //          LEFT JOIN `+ appSettings.masters_db + `.sku_codes sc ON sc.sku_code_id=si.varient_id
    //          LEFT JOIN ` + appSettings.masters_db + `.rack_position rp ON rp.rack_position_id=s.location
    //          LEFT JOIN `+ appSettings.masters_db + `.packing_methods pm ON pm.packing_method_id=si.pack_style_id
    //          LEFT JOIN `+ appSettings.masters_db + `.uoms u ON u.uom_id=pm.uom_id
    //          LEFT JOIN ` + appSettings.masters_db + `.unitcodes uc ON uc.unit_code_id=s.unit_id
    //          LEFT JOIN ` + appSettings.masters_db + `.master_brands b ON b.master_brand_id=s.brand_id
    //          WHERE s.sale_order_id > 0 and state = "`+FgStockStates.AllocatedForRepacking+`"`
    //          query = query + ' GROUP BY s.allocated_sale_order_id,s.allocated_sale_orderitem__id'
    //          const data = await manager.query(query);

    //         if(response.length > 0 || data.length > 0){
    //             return new CommonResponse(true,1001,"Stock Transfer jobs retrived successfully. ",response,data);
    //         }
    //         else{
    //             return new CommonResponse(false,1001,"No data found. ");
    //         }
    //     }
    //     catch (error) {
    //         return error
    //     }
    // }

    async getAllStockTranserMrnData(req: PlantIdRequest): Promise<CommonResponse> {
        const manager = getManager();
        try{
            // let getStockTransferJobs = `select fj.job_code AS jobCode,fj.job_purpose AS jobPurpose, fj.status AS status,so.po_number AS poNumber,u.unit_name AS fromPlant, tu.unit_name AS toPlant,fi.job_cartons AS jobCartons,received_quantity AS receivedQuantity from `+appSettings.warehouse_db+`.fork_lift_items fi left join `+appSettings.warehouse_db+`.fork_lift_jobs fj on fj.job_id = fi.fork_lift_job_id left join `+appSettings.sales_db+`.so_invoice_details so on so.sale_order_id = fi.sale_order_id left join `+appSettings.masters_db+`.unitcodes u on u.unit_code_id=fj.from_plant_id left join `+appSettings.masters_db+`.unitcodes tu on tu.unit_code_id=fj.to_plant_id where fj.job_purpose='stockTransfer'`;
            // if(req.plantId != 5){
            //     getStockTransferJobs = getStockTransferJobs + ` and fj.to_plant_id = `+req.plantId;
            // }
            // getStockTransferJobs = getStockTransferJobs + ` Order by Date(fj.date) DESC , so.po_number`;
            // const response = await manager.query(getStockTransferJobs);
            let getStockTransferJobs = 'select date AS jobDate , job_id AS jobId,job_code AS jobCode,status AS status,job_purpose AS jobPurpose, date AS date, unit_id AS unitId, total_job_cartons AS totalJobCartons, tot_received_quantity AS totReceivedQuantity, excess_quantity AS excessQuantity, damaged_quantity AS damagedQuantity, transfer_status AS transferStatus,uc.unit_name AS fromPlant, u.unit_name AS toPlant, transfer_status AS transferStatus  from '+appSettings.warehouse_db+'.fork_lift_jobs fj LEFT JOIN '+appSettings.masters_db+'.unitcodes uc on uc.unit_code_id = fj.from_plant_id LEFT JOIN '+appSettings.masters_db+'.unitcodes u on u.unit_code_id = fj.to_plant_id where fj.job_purpose = "stockTransfer"';
            if(req.plantId != 5){
                getStockTransferJobs = getStockTransferJobs + ' and fj.to_plant_id = '+req.plantId;
            }
            getStockTransferJobs = getStockTransferJobs + ` Order by Date(fj.date) DESC`;
            const response = await manager.query(getStockTransferJobs);
            if(getStockTransferJobs.length > 0){
                return new CommonResponse(true,1001,"Stock Transfer jobs retrived successfully. ",response);
            }
            else{
                return new CommonResponse(false,1001,"No data found. ");
            }
        }
        catch (error) {
            return error
        }
    }
    async OperateDevice(req: DeviceRequest): Promise<CommonResponse> {
        const manager = getManager();
        try{
          const deviceStatus = await this.forkLiftJobService.getOperateDevice(req);
          console.log(deviceStatus);
        return new CommonResponse(true, 10000, '',deviceStatus);
        }
        catch (error) {
            console.log(error)
            return error
        }
    }
    async updatePlaceListJob(forkLiftJobStatusRequest: ForkLiftJobUpdateRequest): Promise<CommonResponse> {
        try{
            let getJobDetails = await this.forkLiftRepository.findOne({where:{
                reportedId:forkLiftJobStatusRequest.reportedId,jobId:forkLiftJobStatusRequest.jobId
            }})
            let updateForkLiftItemJob = await this.forkLiftItemRepository.update({forkLiftJobId: forkLiftJobStatusRequest.jobId}, {realPosition:forkLiftJobStatusRequest.rackPosition,stockId:forkLiftJobStatusRequest.stockId});
            if(updateForkLiftItemJob.affected > 0){
                let updateForkLiftJob = await this.forkLiftRepository.update({jobId: forkLiftJobStatusRequest.jobId,reportedId:forkLiftJobStatusRequest.reportedId}, {status:ForkLiftJobStatus.Completed,transferStatus:TransferStatusEnum.RECEIVED});
                if(updateForkLiftJob.affected > 0){
                    return new CommonResponse(true,1001,"Job Updated Successfully. ",);
                }
                else{
                    return new CommonResponse(false,1001,"Something went wrong. ",);
                }
            }
            else{
                return new CommonResponse(false,1001,"Something went wrong. ",);
            }
        }
        catch (error) {
            console.log(error)
            return error
        }
    }
    async getJobDetailsByLocation(req: RackPositionIdRequest): Promise<CommonResponse> {
        try{
            const manager = getManager();

            let getJobDetails = "Select flji.* from "+appSettings.warehouse_db+".fork_lift_items flji left join "+appSettings.warehouse_db+".fork_lift_jobs flj on flj.job_id = flji.fork_lift_job_id where flji.target_position ="+req.rackPositionId+" and flj.status != 'Completed' and flji.status = 'IN TRANSIT'";
            let result = await manager.query(getJobDetails);
            if(result.length > 0){
                let getStockDetails = await this.stockRepo.find({where:{stockId:result[0].stock_id}});
                let updateStockStatus = await this.stockRepo.update({stockId:result[0].stock_id},{status:FgStockStatus.StockOut,stockOutQty:getStockDetails[0].stockInQty,totalCartons:0});
                if(updateStockStatus.affected > 0){
                    let updateItemStatus = await this.forkLiftItemRepository.update({forkLiftItemId:result[0].fork_lift_item_id},{status: TransferStatusEnum.RECEIVED, realPosition:req.rackPositionId});
                    if(updateItemStatus.affected > 0){
                        let getitemStatus = "Select count(fli.fork_lift_item_id) AS cnt,fli.fork_lift_job_id AS forkLiftJobId from "+appSettings.warehouse_db+".fork_lift_items fli where fli.status = 'IN TRANSIT'";
                        let getItemsCount = await manager.query(getitemStatus);
                        console.log("getItemsCount");
                        console.log(getItemsCount);

                        if(getItemsCount[0].cnt <= 0){
                            let updateJobStatus = await this.forkLiftRepository.update({jobId:getItemsCount[0].forkLiftJobId},{status:ForkLiftJobStatus.Completed});
                            if(updateJobStatus.affected > 0){
                                let updateRackPositionStatus = "update "+appSettings.masters_db+".rack_position rp set occupancy = 'Not Occupied', sale_order_id = 0 and sale_order_item_id = 0 and is_reserved = false and varient_id = 0 and reserved_date = null where rack_position_id = "+req.rackPositionId;
                                let updateRackStatus = await manager.query(updateRackPositionStatus);
                                if(updateRackStatus.affectedRows > 0){
                                    return new CommonResponse(true,1001,"Stock out done. ");
                                }
                                else{
                                    return new CommonResponse(false,1001,"Something went wrong. ",);
                                }
                            }
                        }
                        else{
                            let updateRackPositionStatus = "update "+appSettings.masters_db+".rack_position rp set occupancy = 'Not Occupied', sale_order_id = 0 and sale_order_item_id = 0 and is_reserved = false and varient_id = 0 and reserved_date = null where rack_position_id = "+req.rackPositionId;
                            let updateRackStatus = await manager.query(updateRackPositionStatus);
                            if(updateRackStatus.affectedRows > 0){
                                return new CommonResponse(true,1001,"Stock out done. ");
                            }
                            else{
                                return new CommonResponse(false,1001,"Something went wrong. ",);
                            }
                        }
                    }
                    else{
                        return new CommonResponse(false,1001,"Job location not found. ",);
                    }
                }
                else{
                return new CommonResponse(false,1001,"Job location not found. ",);
                }
            }
            else{
                return new CommonResponse(false,1001,"Job location not found. ",);
            }
        }
        catch (error) {
            console.log(error)
            return error
        }
    }


}
